export default {
    toggleCreateShopWindowDialog(state){
        state.createShopWindowDialog = !state.createShopWindowDialog
    }
}